export default {
    select_currency_problem: "Select Currency Problem",
    confirm_password:"Check confirm password"
};
